// extracted by mini-css-extract-plugin
export default {"container":"styles_container__IGNoB","nav":"styles_nav__jTAoW","type":"styles_type__iIns+"};